module.exports = __webpack_public_path__ + "img/credit-no-data.png?v=e7ce4cf7";